// extracted by mini-css-extract-plugin
export var button_wraper = "exclusive-module--button_wraper--0e173";
export var cardblock = "exclusive-module--cardblock--bc3ce";
export var left = "exclusive-module--left--35fa6";
export var right = "exclusive-module--right--f9aff";
export var strategy = "exclusive-module--strategy--61c80";